export const date = {
    textAlign: "right"
};
